import axios from "./axios";
import { GET_ORDER_LISTING } from "./APILinks";

export const fetchOrders = async ({
  merchants,
  order_type,
  date,
  order_status,
  payment_status,
  order_id_or_client_name,
  pageSize,
  page,
}) => {
  try {
    return axios.post(
      GET_ORDER_LISTING,
      {
        merchants,
        order_type,
        date,
        order_status,
        payment_status,
        order_id_or_client_name,
        params: {
          page,
          pageSize,
        },
      }
    );
  } catch (e) {
    console.log(e);
  }
};
